export default __webpack_public_path__ + "static/4-small-8dcaec4c7e22c1f46419bf683ec002c6.jpg";